<!-- 便签管理侧边栏（第二列） -->
<template>
  <div class="class1">
    <div class="mid-title">
      <el-row class="m-b m-l">
        <el-col>
          <strong>标签管理中心</strong>
          <el-tooltip content="新建标签" placement="top-start">
            <i data-toggle="tooltip" class="el-icon-plus m-l" :id="triggerTipId" style="cursor: pointer"></i>
          </el-tooltip>
          <addLabelDialog :trigger-tip-selector="triggerTipSelector"></addLabelDialog>
          <br/>
        </el-col>
      </el-row>
      <el-row class="m-l m-r m-b">
        <el-col>
        按照我创建的标签对二维码进行分类、检索、管理
        </el-col>
      </el-row>
    </div>
    <qrLabelList></qrLabelList>
  </div>
</template>

<script type="text/javascript">
import qrLabelList from './qrLabelList.vue'
import addLabelDialog from './addLabelDialog.vue'
import $ from 'jquery'
export default {
  name: 'labelManageSideBar',
  data () {
    return {
      qrlabelList: [],
      triggerTipId: 'addlabel'
    }
  },
  computed: {
    triggerTipSelector () {
      return '#' + this.triggerTipId
    }
  },
  components: {
    qrLabelList,
    addLabelDialog
  },
  mounted () {
    document.title = '美钥二维码 - 便签管理'
    // 查找并初始化二维码列表， 放到vuex中
    const vm = this
    $.ajax({
      url: '/v1/user/qrlabels',
      type: 'GET',
      dataType: 'json',
      success: function (data) {
        if (data.code === 200) {
          vm.$store.dispatch('initQrlabelList', data.data)
        } else {
          vm.$message.warning('错误：' + data.msg)
        }
      },
      error: function () {
        vm.$message.warning('异常，请稍后重试')
      }
    })
  }
}
</script>

<style type="text/css" scoped>
.mid-title{
  background-color: white; 
  padding-top: 15px;
  padding-bottom: 1px;
}
.class1{
  width: 100%;
  /* margin-left: 10px; */
}
</style>
